export default __webpack_public_path__ + "static/media/1878.68723b91.png";